<div class="dc-app-shell">

  <!-- ══ Sidebar ══ -->
  <aside class="dc-sidebar" [class.dc-sidebar--open]="sidebarOpen" aria-label="Điều hướng chính">

    <!-- Brand header -->
    <div class="dc-sb__brand">
      <div class="dc-sb__logo" aria-hidden="true">
        <img src="assets/drct-logo-mark.png" alt="DoctorCity" width="22" height="22" style="display:block;object-fit:contain"/>
      </div>
      <div class="dc-sb__brand-text">
        <div class="dc-sb__brand-name">DoctorCity</div>
        <div class="dc-sb__brand-sub">HỆ THÀNH VIÊN</div>
      </div>
    </div>

    <!-- Nav -->
    <nav class="dc-sb__nav">
      @for (group of navGroups; track group.label) {
        @if (getVisibleItems(group).length) {
          <div class="dc-sb__group">
            <div class="dc-sb__group-header">{{ group.label }}</div>
            @for (item of getVisibleItems(group); track item.path) {
              <button
                class="dc-sb__link"
                [class.active]="isActive(item.path)"
                (click)="navigate(item.path)"
                [attr.aria-current]="isActive(item.path) ? 'page' : null">
                <span class="dc-sb__nav-icon" aria-hidden="true">{{ item.icon }}</span>
                <span class="dc-sb__nav-label">{{ item.label }}</span>
              </button>
            }
          </div>
        }
      }
    </nav>

    <!-- User footer -->
    @if (userData) {
      <div class="dc-sb__user">
        <div class="dc-sb__user-avatar" aria-hidden="true">{{ avatarInitial }}</div>
        <div class="dc-sb__user-info">
          <div class="dc-sb__user-email">{{ userData.email }}</div>
          <div class="dc-sb__user-diamonds">🏵️ {{ userData.diamonds }}</div>
        </div>
        <button class="dc-sb__signout" (click)="signOut()" title="Đăng xuất" aria-label="Đăng xuất">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
          </svg>
        </button>
      </div>
    }
  </aside>

  <!-- Mobile overlay -->
  <div class="dc-overlay" [class.dc-overlay--show]="sidebarOpen" (click)="sidebarOpen=false" aria-hidden="true"></div>

  <!-- ══ Main area ══ -->
  <div class="dc-main">

    <!-- Top bar -->
    <header class="dc-topbar">
      <!-- Mobile hamburger -->
      <button class="dc-topbar__hamburger" (click)="toggleSidebar()" aria-label="Mở menu">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      </button>

      <!-- Brand on mobile -->
      <button class="dc-topbar__brand-mobile" (click)="navigate('/')" aria-label="Trang chủ">
        <div class="dc-topbar__brand-logo" aria-hidden="true">
          <img src="assets/drct-logo-mark.png" alt="" width="14" height="14" style="display:block;object-fit:contain"/>
        </div>
        <span class="dc-topbar__brand-name-mobile">DoctorCity</span>
      </button>

      <div class="dc-topbar__spacer"></div>

      <!-- Diamonds (desktop hidden, show on mobile) -->
      @if (userData) {
        <span class="dc-topbar__diamonds">🏵️ {{ userData.diamonds }}</span>
      }

      <!-- User menu -->
      @if (userData) {
        <div class="dc-topbar__user">
          <button
            class="dc-shell__user-btn dc-topbar__avatar"
            (click)="showUserMenu = !showUserMenu"
            [attr.aria-expanded]="showUserMenu"
            aria-label="Menu tài khoản">
            {{ avatarInitial }}
          </button>
          @if (showUserMenu) {
            <div class="dc-shell__user-menu">
              <div class="dc-shell__user-menu-email">{{ userData.email }}</div>
              <button class="dc-shell__user-menu-item dc-shell__user-menu-item--danger" (click)="signOut(); showUserMenu=false">
                Đăng xuất
              </button>
            </div>
          }
        </div>
      }
    </header>

    <!-- Page content -->
    <div class="dc-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Mobile bottom nav -->
  <nav class="dc-bottom-nav" aria-label="Điều hướng chính (mobile)">
    <button class="dc-bottom-nav__item" [class.active]="isActive('/')" (click)="navigate('/')">
      <span aria-hidden="true">🏠</span>
      <span>Trang chủ</span>
    </button>
    @if (member) {
      <button class="dc-bottom-nav__item" [class.active]="isActive('/quanLyHoSo')" (click)="navigate('/quanLyHoSo')">
        <span aria-hidden="true">📋</span>
        <span>Hồ sơ</span>
      </button>
      <button class="dc-bottom-nav__item" [class.active]="isActive('/quanLyThanhVien')" (click)="navigate('/quanLyThanhVien')">
        <span aria-hidden="true">👥</span>
        <span>Thành viên</span>
      </button>
      <button class="dc-bottom-nav__item" [class.active]="isActive('/interaction-report')" (click)="navigate('/interaction-report')">
        <span aria-hidden="true">📊</span>
        <span>Sự kiện</span>
      </button>
    }
  </nav>

</div>
